import React from "react";
import frontEnd from "../../../images/front-end.svg";
import backEnd from "../../../images/server.svg";
import design from "../../../images/design.svg";
import development from "../../../images/development.svg";

const AboutWork = () => {
    return (
        <div className="bg-light text-dark pb-5">
            <div className="py-4 text-dark">
                <h2 className=" fw-bolder border-bottom border-3 border-primary d-inline">
                    What I Do?
                </h2>
            </div>
            <div className="container">
                <div
                    style={{ textAlign: "justify" }}
                    className="row align-items-start rounded"
                >
                    <div className="col-sm-12 col-md-5 row p-3 m-4 bg-white shadow-lg">
                        <div className="col-sm-12 col-md-4">
                            <img
                                className="img-fluid pb-4"
                                src={design}
                                alt="svg log"
                            />
                        </div>
                        <div className="col-sm-12 col-md-8">
                            <h4>Web Design</h4>
                            <p className="text-secondary">
                                Important things in web design are navigation,
                                effective pages, links. I make these with HTML,
                                CSS and Bootstrap as you mind it's your dream
                                color combination and your website will be a big
                                step for great start.
                            </p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-5 col-md-5 row p-3 m-4 bg-white shadow-lg">
                        <div className="col-sm-12 col-md-4">
                            <img
                                className="img-fluid pb-4"
                                src={development}
                                alt="svg log"
                            />
                        </div>
                        <div className="col-sm-12 col-md-8">
                            <h4>Dom Manipulation</h4>
                            <p className="text-secondary">
                                Dom monipulation is very effective for web pages
                                because it distinguishes between static and
                                dynamic websites. using raw JavaScript and
                                browser Dom I can makes interactive pages who
                                gives your A soft daymaic experience.
                            </p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-5 row p-3 m-4 bg-white shadow-lg">
                        <div className="col-sm-12 col-md-4">
                            <img
                                className="img-fluid pb-4"
                                src={frontEnd}
                                alt="svg log"
                            />
                        </div>
                        <div className="col-sm-12 col-md-8">
                            <h4>Front-end Development</h4>
                            <p className="text-secondary">
                                Introduce to React! an open-source JavaScript
                                library I used to build high-quality user
                                interfaces for web-frontend development, which
                                was developed by Facebook. Its component-based
                                library works with Virtual DOM to give a
                                super-fast experience.
                            </p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-5 row p-3 m-4 bg-white shadow-lg">
                        <div className="col-sm-12 col-md-4">
                            <img
                                className="img-fluid pb-4"
                                src={backEnd}
                                alt="svg log"
                            />
                        </div>
                        <div className="col-sm-12 col-md-8">
                            <h4>Back-end Development</h4>
                            <p className="text-secondary">
                                Node. js is a runtime environment for building
                                backend of web apps using JavaScript. Node. js
                                is very efficient with real-time applications by
                                handeling multiple client requests. Builded API
                                nodeJS, expressJS and mongoDB deliver best
                                performance.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutWork;
